import { render, staticRenderFns } from "./SucursalInventarioList.vue?vue&type=template&id=1b68b275&scoped=true&"
import script from "./SucursalInventarioList.vue?vue&type=script&lang=js&"
export * from "./SucursalInventarioList.vue?vue&type=script&lang=js&"
import style0 from "./SucursalInventarioList.vue?vue&type=style&index=0&id=1b68b275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68b275",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VIcon,VPagination,VSkeletonLoader})
